import { SharedAction,
  LOAD_USER_SUCCESS,
  SIGN_OUT_USER,
  LOAD_USER_DETAIL_SUCCESS,
  SET_DEALER_GROUP_PAGE_LOADING
} from './actions';
import {Reducer, combineReducers } from 'redux';

import { User } from "../../Models/User";
import { LOAD_ALL_DEALER_REPORTS, LOAD_ALL_DEALER_REPORTS_SUCCESS, PerformanceReportAction, SAVE_PERFORMANCEREPORT, SAVE_PERFORMANCEREPORT_SUCCESS, SUBMIT_PERFORMANCEREPORT_TAB, SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS } from '../PerformanceReport/actions';
import { AdminAction, LOAD_USERS_FOR_CLIENT, LOAD_USERS_FOR_CLIENT_SUCCESS } from '../Admin/actions';
export interface SharedState {
  currentUser: User | null;
  initializingApplication: boolean;
  dealerGroupPageLoading: boolean;
  dealerReportsPageLoading: boolean;
  dealerManagementPageLoading: boolean;
  userManagementPageLoading: boolean;
  updateReportDetails: boolean;
}

const INITIAL_STATE: SharedState = {
  currentUser: null,
  initializingApplication: true,
  dealerGroupPageLoading: false,
  dealerReportsPageLoading: false,
  dealerManagementPageLoading: false,
  userManagementPageLoading: false,
  updateReportDetails: false
};

const userReducer = (state: User | null = INITIAL_STATE.currentUser, action: SharedAction) : User | null => {
  switch(action.type) {
    case LOAD_USER_SUCCESS:
      return action.payload.user;
    case LOAD_USER_DETAIL_SUCCESS:
      return {
        ...state,
        ...action.payload.userdetail
      };
    case SIGN_OUT_USER:
      return null;
    default:
      return state;
  }
};

const initializingApplicationReducer = (state: boolean = INITIAL_STATE.initializingApplication, action: SharedAction): boolean => {
  switch(action.type) {
    case LOAD_USER_DETAIL_SUCCESS:
      return false;
    default:
      return state;
  }
};

const pageLoadingReducer = (state: boolean = INITIAL_STATE.dealerGroupPageLoading, action: SharedAction): boolean => {
  switch(action.type) {
    case SET_DEALER_GROUP_PAGE_LOADING:
      return action.payload.isLoading;
    default:
      return state;
  }
};

const dealerReportsPageLoadingReducer = (state: boolean = INITIAL_STATE.dealerReportsPageLoading, action: SharedAction | PerformanceReportAction): boolean => {
  switch(action.type) {
    case LOAD_ALL_DEALER_REPORTS:
      return true;
    case LOAD_ALL_DEALER_REPORTS_SUCCESS:
        return false;
    default:
      return state;
  }
};

const dealerManagementPageLoadingReducer = (state: boolean = INITIAL_STATE.dealerManagementPageLoading, action: SharedAction | PerformanceReportAction ): boolean => {
  switch(action.type) {
    case LOAD_ALL_DEALER_REPORTS:
      return true;
    case LOAD_ALL_DEALER_REPORTS_SUCCESS:
        return false;
    default:
      return state;
  }
};

const userManagementPageLoadingReducer = (state: boolean = INITIAL_STATE.userManagementPageLoading, action: SharedAction | AdminAction ): boolean => {
  switch(action.type) {
    case LOAD_USERS_FOR_CLIENT:
      return true;
    case LOAD_USERS_FOR_CLIENT_SUCCESS:
        return false;
    default:
      return state;
  }
};

const updateReportDetailsReducer = (state: boolean = INITIAL_STATE.updateReportDetails, action: SharedAction | PerformanceReportAction): boolean => {
  switch(action.type) {
    // case SAVE_PERFORMANCEREPORT:    
    case SUBMIT_PERFORMANCEREPORT_TAB:
      return true;
    case SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const sharedReducer: Reducer<SharedState> = combineReducers<SharedState>({
  currentUser: userReducer,
  initializingApplication: initializingApplicationReducer,
  dealerGroupPageLoading: pageLoadingReducer,
  dealerReportsPageLoading: dealerReportsPageLoadingReducer,
  dealerManagementPageLoading: dealerManagementPageLoadingReducer,
  userManagementPageLoading: userManagementPageLoadingReducer,
  updateReportDetails: updateReportDetailsReducer
});